import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import onDemandImage from './assets/on_demand.png';
import messagingImage from './assets/messaging.png';
import newsImage from './assets/news.png';
import chatImage from './assets/chat.png';
import gameImage from './assets/games.png';
import socialImage from './assets/social_media.png';
import photoImage from './assets/photo.png';
import emojiImage from './assets/emoji.png';
import styles from './styles.scss';

function OfferingImages () {
  return (
    <div className="row">
      <div className="col-sm-12">
        <SectionTitle color="#492efd">
          <h3>WHAT DESIGNCUE CAN DO</h3>
        </SectionTitle>
        <div className={`${styles.images} row mt100`}>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={onDemandImage} alt="on-demand apps" />
            <h4>on-demand apps</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={messagingImage} alt="messaging apps" />
            <h4>messaging apps</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={newsImage} alt="news sites" />
            <h4>news sites</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={chatImage} alt="chat bots" />
            <h4>chat bots</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={gameImage} alt="mobile games" />
            <h4>mobile games</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={socialImage} alt="social media networks" />
            <h4>social media networks</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={photoImage} alt="editing apps" />
            <h4>photo editing apps</h4>
          </div>
          <div className="col-sm-3 col-xs-6 demi-bold">
            <img src={emojiImage} alt="emoji apps" />
            <h4>emoji apps</h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfferingImages;



// WEBPACK FOOTER //
// ./src/components/OfferingImages/index.js